import { useEffect, useState } from 'react'

export function CeremonyFilePreview({ file, name }: { file: File; name: string }) {
  const [url, setUrl] = useState<string>()
  const [text, setText] = useState<string>()
  const [failed, setFailed] = useState(false)
  const isImage = file.type.startsWith('image/')
  const isText = file.type.startsWith('text/') || /\.(txt|md|csv|json)$/i.test(file.name)
  useEffect(() => {
    let active = true
    const objectUrl = URL.createObjectURL(file)
    setUrl(objectUrl)
    setText(undefined)
    setFailed(false)
    if (isText && file.size <= 1000000)
      void file
        .text()
        .then((value) => {
          if (active) setText(value)
        })
        .catch(() => {
          if (active) setFailed(true)
        })
    return () => {
      active = false
      URL.revokeObjectURL(objectUrl)
    }
  }, [file, isText])
  if (isImage && !url && !failed)
    return (
      <p role="status" className="text-sm text-muted-foreground">
        Načítání náhledu…
      </p>
    )
  if (isImage && url && !failed)
    return (
      <img
        src={url}
        alt={name}
        onError={() => setFailed(true)}
        className="max-h-[32rem] w-full rounded-lg object-contain"
      />
    )
  if (isText && file.size <= 1000000 && !failed)
    return text !== undefined ? (
      <pre className="max-h-[32rem] overflow-y-auto rounded-lg bg-muted/40 p-4 font-sans text-sm leading-7 break-words whitespace-pre-wrap">
        {text}
      </pre>
    ) : (
      <p role="status" className="text-sm text-muted-foreground">
        Načítání náhledu…
      </p>
    )
  return (
    <p className="text-sm leading-6 text-muted-foreground">
      {failed
        ? 'Náhled se nepodařilo načíst. Soubor si můžete stáhnout.'
        : 'Tento soubor si otevřete po stažení.'}
    </p>
  )
}
